<template>
    <div class="orderTab-bottom" id="orderTab-bottom">{{checkWS}}
        <div class="topMazimize d-flex align-items-center border-bottom justify-content-between" v-if="$route.name == 'custom-view'">
            <p>{{$t('position_list')}}</p>
            <div class="justify-content-end">
                <a href="#" @click.prevent="$parent.$parent.maximize('position')"><feather size="12px" type="maximize-2"></feather></a>
                <a href="#" @click.prevent="$parent.$parent.close('position')"><feather size="12px" type="x"></feather></a>
            </div>
        </div>
        <app-modify-order v-if="Object.keys(tradeMod).length" :trade="tradeMod"></app-modify-order>
        <app-hedge-position v-if="Object.keys(hedgePosition).length" :trade="hedgePosition"></app-hedge-position>
        <div class="topHead border-bottom d-flex justify-content-between align-items-center">
            <tab-section :order="order"/>
            
            <div class="arrowToggle d-flex align-items-center">
                <div class="filterOption position-relative d-flex align-items-center">
                    <a href="javascript:void(0)" class="appButton statusChange" @click="status =!status">
                        <span>{{ currentOperation }}</span>
                        <feather class="ml-1" size="12px" type="chevron-down"></feather>
                    </a>
                    
                    <div class="custonDropDown dropdown-menu" :class="status?'show':''" style="z-index: 99; width: 250px;">
                        <ul class="statusCom">
                            <li v-for="(value, key) in closeType" @click="closeAllPostion(key)">
                                <span>{{ getSum[key].lengthOf }}</span>
                                <label class="mb-0">
                                    {{ value }}
                                </label>
                                <span :class="getPnlTypeColor(getSum[key].sum)" style="float: right;" >{{formatCurrency(getSum[key].sum, accountList.Currency)}}</span> 
                            </li>
                            
                        </ul>
                    </div>
                </div>


                <pagination :totalRecords="openTradeListFiltered.length" :limit="pageLimit" :pageNo="page" :showRecords="false" v-if="order == 'open' && openTradeListFiltered.length > pageLimit"></pagination>
                <a @click="$parent.$parent.setUpFxaccount = !$parent.$parent.setUpFxaccount" class="arrowToggle-buton ml-3" href="#" v-if="$route.name == 'multi-view'"><feather size="15px" type="chevron-up"></feather> </a>
                <button type="button" title="Maximize / Collapse" class="appButton-r d-flex align-items-center justify-content-between" @click="addRemBodyClass()" v-if="$route.name == 'home'">
                    <feather class="showMin" size="15px" type="maximize-2"></feather>
                    <feather class="showMax d-none" size="15px" type="minimize-2"></feather>
                    
                </button>

                
            </div>
        </div>
        <div class="responsiveTable scrollbar bottomTable fixedHead" v-if="order == 'open'">
            <table class="table text-center last-child stickyHead stickyActionButton">
                <thead class="border-0" v-if="openTradeListFiltered.length > 0">
                    <tr>
                        <th>{{$t('trade_id')}} </th>
                        <th>{{$t('open_time')}}</th>
                        <th>{{$t('sell_buy')}}</th>                        
                        <th v-if="userSettings.position_size && userSettings.position_size == '1'">{{$t('units')}}</th>
                        <th  v-else>{{$t('lots')}}</th>
                        <th>{{$t('instrument')}}</th>
                        <!-- <th>Current Price</th> -->
                        <th>{{$t('open_current_price')}}</th>
                        <th>{{$t('s_slash_l')}}</th>
                        <th>{{$t('trail_s_slash_l')}}</th>
                        <!-- <th>CMP</th> -->
                        <th>{{$t('tp')}}</th>
                        <th>{{$t('commission')}}</th>
                        <th>{{$t('swap')}}</th>
                        <th>{{$t('net_pl')}}</th>
                        <th>{{$t('comment')}}</th>
                        <th>{{$t('action')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="list,index in openTradeListFiltered" v-if="index >= (page - 1)*pageLimit && index < page*pageLimit" :class="{'active-order':modifyTradeID == list.TradeID}">
                        <td>{{list.TradeID}}</td>
                        <!-- <td>{{list.OpenTime | moment('HH:mm:ss - DD-MM-YYYY')}}</td> -->
                        <!-- <td>{{formatDateTime(list.date)}}</td> -->
                        <td>{{formatDateTime(list.OpenTime)}}</td>
                        <td :class="sideClass[list.Side]">{{sideValue[list.Side] || '-'}}</td>
                        <td>{{getQuantity(list)}}</td>
                        <td>{{list.Symbol}}</td>
                        <td style="min-width:150px">{{list.Price}}-><span :class="priceColor(instruments[list.Symbol],side)">{{currentP(list.Symbol,parseInt(list.Side))}}</span></td>
                        <!-- <td v-if="parseInt(list.Side) == 1">{{currentP(instruments[list.Symbol],parseInt(list.Side))}}</td> -->
                        <!-- <td>{{currentP(instruments[list.Symbol],parseInt(list.Side))}}</td> -->

                        <td>{{tradeSl_TP(list,'S').Price || '0'}}</td>
                        <td>{{ getTrail(list).Trail || '0'}}</td>
                        <td>{{tradeSl_TP(list,'L').Price || '0'}}</td>
                        <!-- <td>-</td> -->
                        <td>{{formatCurrency((list.Commission || 0), accountList.Currency)}}</td>
                        <td>{{formatCurrency((list.Interest || 0), accountList.Currency)}}</td>

                        <td :class="[{'red':getPl(list,instruments[list.Symbol])<0,'green':getPl(list,instruments[list.Symbol])>0}]" style="min-width:100px">
                            {{formatCurrency(getPl(list,instruments[list.Symbol]), accountList.Currency)}}</td>
                        <td>{{ (providerName ? ('Trade By '+providerName) : '') || checkTradeBy(list.Commentary) || '-'}}</td>
                        <td>
                            <span class="d-flex align-items-right" v-if="delTrade.includes(list.TradeID)">
                                <!-- <a @click.prevent="modifyOrder = 'true' " class="td-button" href="#"><feather size="12px" type="edit"></feather></a> -->
                                <a class="td-button disabled" href="#"><feather size="12px" type="edit"></feather></a>
                                <a class="td-button disabled" href="#">H</a>
                                <a class="td-button disabled closeBtn" href="#" ><feather size="12px" type="x"></feather></a>
                            </span>
                            <span class="d-flex align-items-right" v-else>
                                <!-- <a @click.prevent="modifyOrder = 'true' " class="td-button" href="#"><feather size="12px" type="edit"></feather></a> -->
                                <a data-toggle="tooltip" data-placement="top" title="Edit Position"  @click.prevent="editTrade(list)" class="td-button" href="#"><feather size="12px" type="edit"></feather></a>
                                <template v-if="product != 'Capital-Street'">
                                      <a data-toggle="tooltip" data-placement="top" title="Hedge Position"   @click.prevent="openHedgePosition(list)" class="td-button" href="#" v-if="!list.Commentary.includes('Hedge') && (product != 'Capital-Street')">H</a>
                                    <a class="td-button" href="#" @click.prevent="closeTradeHedge(list) && (product != 'Capital-Street')" v-else>CH</a>
                                </template>
                                <!-- <a @click.prevent="modifyOrder = 'true' " class="td-button" href="#"><feather size="12px" type="x"></feather></a> -->

                                <a data-toggle="tooltip" data-placement="top" title="Partial Close"  v-if="instruments[list.Symbol] && list.Quantity/instruments[list.Symbol].other.market_ContractSize == instruments[list.Symbol].other.Min_Trade_Size" class="td-button disabled" href="#"><feather size="12px" type="pie-chart"></feather></a>
                                <a data-toggle="tooltip" data-placement="top" title="Partial Close" v-else @click.prevent="openMofifyTrade(list,tradeSl_TP(list,'S'),tradeSl_TP(list,'L'),(list.Trail || getTrail(list) || ''))" class="td-button" href="#"><feather size="12px" type="pie-chart"></feather></a>

                                <a data-toggle="tooltip" data-placement="top" title="Close Position" class="td-button closeBtn" href="#"  @click.prevent="closeTrade(list)"><feather size="12px" type="x"></feather></a>
                            </span>
                        </td>
                    </tr>
                    <tr v-if="openTradeListFiltered.length == 0">
                        <td class="noData border-0 h-100">
                            <app-loader v-if="pageLoader"/>
                            <no-data v-else text="No Open Trades"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- <div v-if="plotted.length!=0">
            <div v-for="tradeid in plotted" :id="`drag_${tradeid}`" :key="tradeid" @mousedown="startDrag(tradeid, $event)" :style="{background: 'var(--default-topbar)', position:'absolute', 'z-index':9, 'left': tradeData[tradeid]['x']+ 'px', 'top': tradeData[tradeid]['y']+ 'px', border: '1px solid var(--green)'}" class="open_trade_chart">
                <b class="float-left px-2" :id="`open_trade_${tradeid}`">Pnl  </b><div class="float-left px-2">{{ tradeData[tradeid]['comment']?tradeData[tradeid]['comment']:'-' }}</div>
                <div class="float-left px-2" role="button" @click="closeTradeFromChart(tradeid)" data-toggle="tooltip" data-placement="top" title="Close Position"><feather size="12px" type="x"></feather></div>
            </div>
        </div> -->
        

    </div>
</template>
<script>
import app_modify_order from './modify-order/open-order-modify'
import hedge_position from './modify-order/hedge-position'
import tab_section from './tab-section'
import { commonAllmixins } from '@/plugins/commonAll'
import { Const } from '@/plugins/vue-provider-cache/const.mod';
const product_type = process.env.product_type;
const product = process.env.product;
export default {
    name: 'position-list',
    mixins: [commonAllmixins],
    data() {
        return {
            pageLoader: false,
            page : '1',
            // pageLimit : '5',
            sideClass:{
                '0':'red',
                '1':'green',
            },
            sideValue:{
                '0':'Sell',
                '1':'Buy',
            },
            closedManually:[],
            tfc:true,
            status: false,
            closeType:{'closeall': 'Close All Trades', 'closeprofit': 'Close All Profit', 'closeloss': 'Close All Loss'},
            pnlPerType:{'closeall': 0, 'closeprofit': 0, 'closeloss': 0},
            currentOperation:'Close All',
            tradeMod:{},
            hedgePosition:{},
            tempOrderId:[],
            delTrade:[],
            tradePnl:{},
            openTradeCount:{'closeall': 0, 'closeprofit': 0, 'closeloss': 0},
            tempReg:[],

            // plotted:[],
            // tradeData:{},
            // draggedTradeId: null,
            // initialX: 0,
            // dragging: false,
            currencyIcon: { EUR: "€", USD: "$", GBP: "£", CHF: "CHF", JPY: "¥", AUD: "$", "CAD": "C$", BTC:"₿"},
            product
        }
    },
    components:{
        appModifyOrder:app_modify_order,
        appHedgePosition:hedge_position,
        tabSection:tab_section,
    },
    props:{
        pageLimit:{
            type: Number,
            default: 5
        },
        order:{
            default: 'open'
        },
        providerId:{
            default: null
        },
        providerName:{
            default: null
        },
        modifyTradeID:{
            default: null
        },
        modifyOrderID:{
            default: null
        }
    },
    watch:{
        currency_pair(val){
            console.log(val)``
            this.plotted=[]
        }
    },
    emits:['modifyTrder'],
    methods:{
        /*startDrag(tradeid, event) {
            this.draggedTradeId = tradeid;
            this.dragging = true;
            this.initialY = event.clientX - this.tradeData[tradeid].x;

            document.body.style.userSelect = 'none';
            document.addEventListener("mousemove", this.drag);
            document.addEventListener("mouseup", this.stopDrag);
        },
        drag(event) {
            if (this.dragging) {
                const tradeid = this.draggedTradeId;
                this.tradeData[tradeid].x = event.clientX - this.initialX; // Only update Y position

                document.getElementById(`drag_${tradeid}`).style.left = this.tradeData[tradeid].x + 'px';
            }
        },
        stopDrag() {
            this.dragging = false;
            this.draggedTradeId = null;
            
            document.body.style.userSelect = '';
            document.removeEventListener("mousemove", this.drag);
            document.removeEventListener("mouseup", this.stopDrag);
        },*/
        async editTrade(item) {
            if(this.$route.name == 'home'){
                let trade = item;
                if (this.modifyTradeID || this.modifyOrderID) {
                    this.$emit('modifyTrder', null);
                    await new Promise(resolve => setTimeout(resolve, 300));
                }
                trade['SL'] = this.tradeSl_TP(item,'S');
                trade['TP'] = this.tradeSl_TP(item,'L');
                trade['Trail'] = this.getTrail(item)
                this.$emit('modifyTrder',trade);
            }else{
                this.openMofifyTrade(item,this.tradeSl_TP(item,'S'),this.tradeSl_TP(item,'L'),(item.Trail || this.getTrail(item) || ''));
            }
        },
        checkTradeBy(text){
            if(text.split('-').length == 3){
                return 'Copy Trade';
            }else{
                return text;
            }
        },
        closeAllPostion(type){
            const _that = this
            const ptype=type
            let message='Are you sure you want to close all open trades at the current market rates?'

            if(type=='closeprofit') message='Are you sure you want to close all profit trades at the current market rates?';
            if(type=='closeloss') message='Are you sure you want to close all loss trades at the current market rates?'

            this.$confirm(
            { message: message,
            button: {
                no: 'No',
                yes: 'Yes'
            },
            /**
             * Callback Function
             * @param {Boolean} confirm
             */
                callback: confirm => {
                    if (confirm) {
                        // ... do something
                        // for(var index in _that.openTradeListFiltered) {
                        //     const orderData = _that.openTradeListFiltered[index]
                        //     console.log(orderData);
                        //     if(ptype=='closeprofit' && this.getPl(orderData,this.instruments[orderData.Symbol])>0) _that.closeTrade(orderData);
                        //     else if(ptype=='closeloss' && this.getPl(orderData,this.instruments[orderData.Symbol])<0) _that.closeTrade(orderData);
                        //     else if(ptype=='closeall') _that.closeTrade(orderData);
                        // }

                        _that.openTradeListFiltered.forEach(orderData => {
                            const pl = this.getPl(orderData, this.instruments[orderData.Symbol]);
                            if (
                                (ptype === 'closeprofit' && pl > 0) ||
                                (ptype === 'closeloss' && pl < 0) ||
                                ptype === 'closeall'
                            ) {
                                _that.closeTrade(orderData);
                            }
                        });
                        this.status = false;
                    }
                }
            })
        },

        closeTradeFromChart(tradeId){

            const orderData = this.openTradeListFiltered.find(orderData => orderData.TradeID === tradeId);
            if (orderData) {
                this.closeTrade(orderData);
                const elementToRemove = tradeId;
                if (this.plotted.includes(elementToRemove)) {
                    this.plotted.splice(this.plotted.indexOf(elementToRemove), 1);
                }
                this.closedManually.push(tradeId)
            }
        },
        
        getPnlTypeColor(pnlType){
            if(pnlType<0){
                return 'red'
            } else if(pnlType>0){
                return 'green'
            } else{
                return ''
            }
        },
        addRemBodyClass(){
            if($(document.getElementsByClassName('maxCollapse')).hasClass('maximizeToggle')){
                $(document.getElementsByClassName('maxCollapse')).removeClass('maximizeToggle')

                $(document.getElementsByClassName('splitTop')).height('calc(100vh - 290px)')

                if(this.$route.name == 'home'){
                    this.$parent.pageLimit = 5
                }
            }else{
                $(document.getElementsByClassName('maxCollapse')).addClass('maximizeToggle')
                $(document.getElementsByClassName('splitTop')).height(0)
                if(this.$route.name == 'home'){
                    this.$parent.pageLimit = 10
                }
            }
        },
        getQuantity(list){
            let lotBy = 100000
            try {
                lotBy = this.currencyPairs.find(val => val.isinid === list.Symbol)
                    .market_ContractSize || 100000;
            } catch (e) {}
            if(this.userSettings.position_size && this.userSettings.position_size == '1'){
                return list.Quantity
            }else{
                const qty = list.Quantity?(list.Quantity / lotBy):0;
                return Math.round(qty * 100) / 100;
            }
        },
        /*getQuantity(list){
            let lotBy = 100000
            try{
                // lotBy = this.currencyPairs.filter(val=>val.isinid.includes(list.Symbol))[0].market_ContractSize || 100000
                // lotBy = ((this.instruments[list.Symbol] || {}).other || {}).market_ContractSize
                lotBy = this.currencyPairs.filter((val)=>val.isinid.includes( list.Symbol.slice(0,6)))[0].market_ContractSize || ((this.instruments[list.Symbol] || {}).other || {}).market_ContractSize || 100000
            }catch(e){
                console.log("ex", e)
            }
            if(this.userSettings.position_size && this.userSettings.position_size == '0'){
                return list.Quantity
            }else{
                return list.Quantity?(list.Quantity / lotBy):0
            }
        },*/
    	currentP(symbol,side){
    		try{
                const instruments = this.instruments[symbol] || {};
                // const precision = instruments.other.Tick_Size.split(".")[1].length;
                const tickSizeParts = instruments.other.Tick_Size.split(".");
                const precision = tickSizeParts[1] ? tickSizeParts[1].length : 0;
                if(side == 1) return (parseFloat(instruments.B).toFixed(precision))
                else return (parseFloat(instruments.A).toFixed(precision))
    		}catch(e){ 
                // console.log(e);
                return '-'
            }
    	},
        priceColor(instruments,side){
            try{
                if(instruments){
                    if(side == 1) return (instruments.buy_increase_staus==1)?'green':'red';
                    else return (instruments.sell_increase_staus==1)?'green':'red';
                }else{
                    return '-'
                }
                
    		}catch(e){ console.log(e);return '-'}
        },
       
        openMofifyTrade(list,SL,TP,Trail){
            this.tradeMod = list
            this.tradeMod['SL'] = SL
            this.tradeMod['TP'] = TP
            this.tradeMod['Trail'] = Trail
        },
        openHedgePosition(list){
            this.hedgePosition = list
        },
    	getPl(list,instruments){
            return this.getProfitLoss(this.accountList.Currency, list, instruments, this.instruments)
    	},
        getProfitLoss(accountCurrency, order, symbol, isins) {
            try {
                if(symbol==undefined) return 0
                else{
                    let quantity = order.Quantity;
                    let commission = parseFloat(order.Commission || 0);
                    let interest = parseFloat(order.Interest || 0);
                    let price = parseFloat(order.Price);
                    let askPrice = parseFloat(symbol.A);
                    let bidPrice = parseFloat(symbol.B);

                    let BSprice = order.Side === 1 ? bidPrice - price : price - askPrice;

                    let currencyConverter = this[product === 'Hanko' ? 'convertCurrencyHKT' : 'convertCurrencyNew'];
                    let convertedAmount = parseFloat(currencyConverter(accountCurrency, symbol, this.instruments, order.Side, order.Symbol));
                    
                    let toFixedValue = accountCurrency === 'BTC' ? 8 : 2;
                    let pnl = (BSprice * quantity * convertedAmount) + commission + interest;

                    return pnl.toFixed(toFixedValue);
                }
                
            } catch (e) {
                // console.log(e);
                return 0;
            }
        },
        convertCurrencyNew(accountCurrency, symbol, isins, side, orderSymbol) {
            symbol.other.base_currency = symbol.other.base_currency.split('_V')[0];
            const base = symbol.other.base_currency;
            const acc = accountCurrency //.toUpperCase();
            const product = product_type; // assuming it's globally accessible

            if (acc === base) return 1;

            const getPossibleKeys = (cur1, cur2) => [
                `${cur1}/${cur2}${product_type}`,
                `${cur1}${cur2}.`,
                `${cur1}${cur2}_`,
                `${cur1}${cur2}${product_type}`
            ];

            const tryGetRateFromPairs = (cur1, cur2, invert = false) => {
                if(cur1 == cur2) return 1
                const keys = getPossibleKeys(cur1, cur2);
                if ((cur1 === 'BTC' && cur2 === 'USD') || (cur1 === 'USD' && cur2 === 'BTC')) keys.push('Bitcoin');
                for (const key of keys) {
                    const item = isins[key];
                    if (item && item.A) return invert ? 1 / item.A : item.A;
                }
                return null;
            };

            // 1. Try direct and inverse rates
            let rate = tryGetRateFromPairs(acc, base, true) || tryGetRateFromPairs(base, acc, false);
            if (rate) return rate;

            // 2. Use USD as intermediary
            const toUSD = tryGetRateFromPairs(base, 'USD' + product) || tryGetRateFromPairs('USD', base + product, true);
            const fromUSD = 
                tryGetRateFromPairs(acc, 'USD' + product, true) ||
                tryGetRateFromPairs('USD', acc + product) ||
                tryGetRateFromPairs(acc, product);

            // console.log('===fromUSD==>', toUSD/fromUSD)

            if (fromUSD && toUSD) return ((toUSD == 1) ? toUSD/fromUSD : fromUSD * toUSD);

            // 3. Fallback using symbol directly
            const fallbackKey = acc + product;
            if (isins[fallbackKey]) {
                return Number(symbol.A || 1) / Number(isins[fallbackKey].A || 1);
            }

            return 1; // final fallback
        },
        convertCurrencyNew_old(accountCurrency, symbol, isins, side,orderSymbol){
            
            symbol.other.base_currency = symbol.other.base_currency.split('_V')[0]

            if(accountCurrency==symbol.other.base_currency){
                return 1
            }else{
                let isGet = false
                const firstCurrency = accountCurrency.toUpperCase()+symbol.other.base_currency+""

                if(isins[firstCurrency]){
                    return 1/isins[firstCurrency].A;
                    isGet = true;
                }
                
                const firstCurrencyWithSlash = accountCurrency.toUpperCase()+symbol.other.base_currency+""
                
                if(isins[firstCurrencyWithSlash]){
                    return 1/isins[firstCurrencyWithSlash].A
                    isGet = true;
                }
                
                const secondCurrency = symbol.other.base_currency+accountCurrency.toUpperCase()
                
                if(isins[secondCurrency]){
                    return isins[secondCurrency].A
                    isGet = true;
                }
                const secondCurrencyWithSlash = symbol.other.base_currency+accountCurrency.toUpperCase()+""
                
                if(isins[secondCurrencyWithSlash]){
                    return isins[secondCurrencyWithSlash].A
                    isGet = true;
                }
                let secontoUSD = 0
                let accBasetoUSD = 0
                if(isins[symbol.other.base_currency+"USD"+product_type]   ){
                    secontoUSD = isins[symbol.other.base_currency+"USD"+product_type].A
                    isGet = true;
                } 
                else if(isins['USD'+symbol.other.base_currency+product_type]){
                    secontoUSD = 1/isins['USD'+symbol.other.base_currency+product_type].A
                    isGet = true;
                } 
                
                if(isins[accountCurrency.toUpperCase()+'USD'+product_type]){
                    accBasetoUSD = 1/isins[accountCurrency.toUpperCase()+'USD'+product_type].A
                    isGet = true;
                } 
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                    isGet = true;
                }
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                    isGet = true;
                }
                else if(isins[accountCurrency+product_type]){
                    // console.log('------------',isins['UGOLDUSD'])
                    return Number(symbol.A || 1)/Number(isins[accountCurrency+product_type].A || 1)
                }
                /*if(!isGet){
                    this.subscribeIsisn(firstCurrency)
                    this.subscribeIsisn(firstCurrencyWithSlash)
                    this.subscribeIsisn(secondCurrency)
                    this.subscribeIsisn(secondCurrencyWithSlash)
                    this.subscribeIsisn(symbol.other.base_currency+"USD"+product_type)
                    this.subscribeIsisn('USD'+symbol.other.base_currency+product_type)
                    this.subscribeIsisn(accountCurrency.toUpperCase()+'USD'+product_type)
                    this.subscribeIsisn('USD'+accountCurrency.toUpperCase()+product_type)
                }*/
                return accBasetoUSD * secontoUSD
            }
        },

        convertCurrencyHKT(accountCurrency, symbol, isins, side,orderSymbol){

            symbol.other.base_currency = symbol.other.base_currency

            if(accountCurrency==symbol.other.base_currency){
                return 1
            }else{
                let isGet = false
                const firstCurrency = accountCurrency.toUpperCase()+symbol.other.base_currency+product_type

                // console.log("firstCurrency", firstCurrency);

                if(isins[firstCurrency]){
                    return 1/isins[firstCurrency].A;
                    isGet = true
                }

                const firstCurrencyWithSlash = accountCurrency.toUpperCase()+symbol.other.base_currency+product_type

                if(isins[firstCurrencyWithSlash]){
                    return 1/isins[firstCurrencyWithSlash].A;
                    isGet = true;
                }

                const secondCurrency = symbol.other.base_currency+accountCurrency.toUpperCase()+product_type

                

                if(isins[secondCurrency]){
                    return isins[secondCurrency].A;
                    isGet = true;
                }
                const secondCurrencyWithSlash = symbol.other.base_currency+accountCurrency.toUpperCase()+product_type

                if(isins[secondCurrencyWithSlash]){
                    return isins[secondCurrencyWithSlash].A;
                    isGet = true;
                }
                
                //===============================if not found
                let secontoUSD = 0
                let accBasetoUSD = 0
                if(isins[symbol.other.base_currency+"USD"+product_type]   ){
                    secontoUSD = isins[symbol.other.base_currency+"USD"+product_type].A
                    isGet = true;
                } 
                else if(isins['USD'+symbol.other.base_currency+product_type]){
                    secontoUSD = 1/isins['USD'+symbol.other.base_currency+product_type].A
                    isGet = true;
                } 
                
                if(isins[accountCurrency.toUpperCase()+'USD'+product_type]){
                    accBasetoUSD = 1/isins[accountCurrency.toUpperCase()+'USD'+product_type].A
                    isGet = true;
                } 
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                    isGet = true;
                }
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                    isGet = true;
                }
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                    isGet = true;
                }
                if(!isGet){
                    this.subscribeIsisn(firstCurrency)
                    this.subscribeIsisn(firstCurrencyWithSlash)
                    this.subscribeIsisn(secondCurrency)
                    this.subscribeIsisn(secondCurrencyWithSlash)
                    this.subscribeIsisn(symbol.other.base_currency+"USD"+product_type)
                    this.subscribeIsisn('USD'+symbol.other.base_currency+product_type)
                    this.subscribeIsisn(accountCurrency.toUpperCase()+'USD'+product_type)
                    this.subscribeIsisn('USD'+accountCurrency.toUpperCase()+product_type)
                }
                return accBasetoUSD * secontoUSD
            }
        },

        convertCurrency (accountCurrency, symbol, isins){
            let secondCurrency = symbol.substring(3, 6);
            if (this.segm == "crypto") {
                secondCurrency = symbol.substring(4, 7);
                let basecurreny =
                    accountCurrency == "BTC"
                        ? "BTC-"
                        : accountCurrency;
                if (secondCurrency == basecurreny) {
                    return 1;
                } else {
                    return 1 / isins[basecurreny + secondCurrency].A;
                }
            }
            if (secondCurrency == accountCurrency) {
                return 1;
            } else if (
                isins[secondCurrency + accountCurrency]
            ) {
                return isins[
                    secondCurrency + accountCurrency
                ].A;
            } else if (
                isins[accountCurrency + secondCurrency]
            ) {
                return (
                    1 /
                    isins[
                        accountCurrency + secondCurrency
                    ].A
                );
            } else {
                let secontoUSD = 0;
                let accBasetoUSD = 0;
                if (secondCurrency == "USD") {
                    secontoUSD = 1;
                } else if (isins[secondCurrency + "USD"]) {
                    secontoUSD = isins[secondCurrency + "USD"].A;
                } else if (isins["USD" + secondCurrency]) {
                    secontoUSD = 1 / isins["USD" + secondCurrency].A;
                }

                if (accountCurrency == "USD") {
                    accBasetoUSD = 1;
                } else if (accountCurrency == "BTC") {
                    accBasetoUSD =
                        1 /
                        isins[accountCurrency + "-USD"].A;
                } else if (
                    isins[accountCurrency + "USD"]
                ) {
                    accBasetoUSD =
                        1 /
                        isins[accountCurrency + "USD"].A;
                } else if (
                    isins["USD" + accountCurrency]
                ) {
                    accBasetoUSD =
                        isins["USD" + accountCurrency].A;
                }
                return accBasetoUSD * secontoUSD;
            }
        
        },
        subscribeIsisn(isin){
            isin = isin.replace('/','')
            if(this.tempReg.includes(isin)){
                return;
            }else{
                // console.log('isin not reg',isin)
                this.tempReg.push(isin);
                this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].subscribe([isin])
            }
        },

        tradeSl_TP(list,type){
    		try{
    			let close = this.pendingOrderList.filter(val=>(val.TradeID == list.TradeID || val.ToClose == list.TradeID || val.OpenOrderID == list.TradeID || (list.OpenOrderID && val.ToClose == list.OpenOrderID)) && val.Type == type)
    			return (close.length)?close[0]:{}
    		}catch(e){ return {}}
    	},
    	getTrail(order){
            let TradeID = order.TradeID
            let OpenOrderID = order.OpenOrderID
    		try{
    			let close = this.pendingOrderList.filter(val=> (val.TradeID == TradeID || val.ToClose == TradeID || ( OpenOrderID ? val.ToClose == OpenOrderID : false ) || val.OpenOrderID == TradeID) && val.Type == 'S')
    			return (close.length)?close[0]:{}
    		}catch(e){return {}}
    	},
		successWs(){
			// console.log('cancle Order ws')
		},
        failedWs(){
        	this.displayError('There is some network issue','error')
        },
        displayError(getMessage,type){
            this.$notify({
                group: 'foo',
                type: (type && type == null)?'error':type,
                text: getMessage,
                duration: 4000,
                closeOnClick: true
            });
        },
        closeTrade(item){
            const tempOrderId = new Date().getTime()
            if(this.modifyTradeID == item.TradeID){
                this.$emit('modifyTrder',null);
            }
            let orderJson = {
				"symbol" : item.Symbol,
                "trade" : item.TradeID,
                "quantity" : item.Quantity,
				"tempOrderId" : tempOrderId,
				'localParams':this
			}
            this.delTrade.push(item.TradeID)
            this.tempOrderId.push(tempOrderId)
			// console.log('closeTrade->',item)
            this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
				.seeders['S_PF_PF'].closeTrade(orderJson)
            
            // this.closedManually.push(item.TradeID)
            // const elementToRemove = item.TradeID;
            // if (this.plotted.includes(elementToRemove)) {
            //     this.plotted.splice(this.plotted.indexOf(elementToRemove), 1);
            // }
                
        },
        closeTradeHedge(item){
            const tempOrderId = new Date().getTime()
            let orderJson = {
				"symbol" : item.Symbol,
                "trade" : item.TradeID,
                "quantity" : item.Quantity,
				"tempOrderId" : tempOrderId,
                "closeType": "H",
				'localParams':this
			}
            this.delTrade.push(item.TradeID)
            this.tempOrderId.push(tempOrderId)
            this.$store.getters[Const.GET_PROVIDERS]['priceFeed'] .seeders['S_PF_PF'].closeTrade(orderJson)
        },
        OpenTradeListing(){
            this._runGetOpenTradeList({ 'globalParams' : {},'localParams' : { 'parameter' : this } })
        },
        
    },
    computed:{
        getSum(){
            let _that = this
            // let idList = this.openTradeList.map(v=>v.Commentary.includes(this.providerId))
            /*let TradeID = this.openTradeList.map(v=>v.TradeID);
            let removedElements = [];
            let plotted = this.plotted.filter(item => TradeID.includes(item) || removedElements.push(item));
            if(removedElements.length){
                removedElements.forEach(v=>{
                    if(!this.closedManually.includes(v)){
                        // console.log('---------removedElements------>',removedElements)
                        this.closedManually.push(v)
                        if (this.plotted.includes(v)) {
                            this.plotted.splice(this.plotted.indexOf(v), 1);
                        }
                    }
                })
                // this.closedManually = [...new Set([...this.closedManually, ...removedElements])];
            }*/
            // console.log('-------plotted--',plotted)
            const result = this.openTradeListFiltered.reduce((acc, item) => {
                if(!_that.delTrade.includes(item.TradeID)){
                    let curr = Number(_that.getPl(item,_that.instruments[item.Symbol]));
                    /*let el = document.getElementById("open_trade_"+item.TradeID)
                    if(this.accountList && item && el){
                        el.innerHTML=this.formatCurrency(curr, this.accountList.Currency);
                        (curr > 0)?(el.classList.remove('red'),el.classList.add('green')):'';
                        (curr < 0)?(el.classList.remove('green'),el.classList.add('red')):'';
                    }*/

                    acc.sumAll += curr;
                    acc.totalElements += 1;
    
                    if (curr > 0) {
                        acc.sumPositive += curr;
                        acc.totalPositive += 1;
                    } else if (curr < 0) {
                        acc.sumNegative += curr;
                        acc.totalNegative += 1;
                    }
                }

                return acc;
            }, { 
                sumPositive: 0, 
                sumNegative: 0, 
                sumAll: 0, 
                totalPositive: 0, 
                totalNegative: 0, 
                totalElements: 0 
            });
            return {
                'closeall':{ lengthOf : result.totalElements , sum :  result.sumAll },
                'closeprofit':{ lengthOf : result.totalPositive , sum : result.sumPositive },
                'closeloss':{ lengthOf : result.totalNegative , sum : result.sumNegative },
            }
        },
        openTradeListFiltered(){
            if(this.providerId){
                return this.openTradeList.filter(v=>v.Commentary.includes(this.providerId)) || []
            }else{
                return this.openTradeList;
            }
        },
        checkWS(){
            let _that = this
            this.tempOrderId.forEach(val=>{
                if(_that.wsOrder.hasOwnProperty(val)){
                    let msg = _that.wsOrder[val].resp_msg
                    let msgType = (_that.wsOrder[val].stat == 'OK')?'success':'error'
                    _that.displayError(msg,msgType)
                    const id = msg.match(/Trade (\d+)/);
                    if(_that.wsOrder[val].stat == 'OK' && id && id[1]){
                        let newList = _that.openTradeList.filter(val=>val.TradeID != id[1]);
                        _that.$store.commit('/SET_OPEN_TRADE', newList);
                    }
                    _that.tempOrderId.splice(_that.tempOrderId.indexOf(val), 1)
                }
            })
        },
    	instruments() {
    	    try {                    
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {
	            return {}
	        }
	    },
    },
    created(){
        if(this.openTradeList.length == 0 || this.$route.name == 'custom-view'){
            this.OpenTradeListing()
        }
    },
    mounted(){
        const _that=this
        setTimeout(()=>{
            /*const d = document.getElementById("charScreeen");
            const leftPos = d.offsetLeft;
            const topPos = d.offsetTop+46;
            const belowPos = (topPos + d.offsetHeight)-140;

            TFC.prototype.plotOpenTrades = function (x, y, trade) {
                if(_that.closedManually.indexOf(trade.id)==-1 && window['myStxx'] && window['myStxx'].tfc && window['myStxx'].tfc._isOpen){
                    if(y+90<belowPos && y+90>topPos ){
                        
                        if(_that.plotted.indexOf(trade.id)==-1){
                            _that.tradeData[trade.id]={"x": leftPos+40, "y": y+90}
                            _that.plotted.push(trade.id)
                            _that.tradeData[trade.id]["comment"]=_that.sideValue[trade.side]+" lot "+trade.quantity
                        }


                        
                        (_that.tradeData && _that.tradeData[trade.id])?_that.tradeData[trade.id]["y"]=y+90:'';
                        (_that.tradeData && _that.tradeData[trade.id] && document.getElementById(`drag_${trade.id}`))?document.getElementById(`drag_${trade.id}`).style.top = _that.tradeData[trade.id].y + 'px':'';
                        
                    }else{
                        _that.plotted=[]
                    }
                }else{
                    
                    if(window['myStxx'] && !(window['myStxx'].tfc._isOpen)){
                        $(".open_trade_chart").remove();
                        _that.plotted=[]
                    }
                    
                }
            };*/

            TFC.prototype.editTradeFromSlTP=function(tradeid){
                const orderData = _that.openTradeListFiltered.find(orderData => orderData.TradeID === tradeid);
                _that.editTrade(orderData)
            }
            /*TFC.prototype.clearOpenTrades = function () {
                $(".open_trade_chart").remove();
                _that.plotted=[];
            };*/
        }, 1100)
            
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/order/position-list.vue